// test2110
(2110 && 0);
